export const singleDefaults = {
  cover_trade_type: 'all',
  cover_trade_value: '',
  trade_type: 'num_of_shares',
  timeframe: 'every day',
  name: '',
  strategy: '',
  take_profit: '',
  stop_loss: '',
  signal: '',
  tickers: [],
  trade_value: '',
  has_coin: false,
  stock_filter: {id:''}
}

export const saveDefaults = {
  tickers: [],
  stock_filter: {id:''}
}
